import { Skeleton, SkeletonGroup } from '@cian/ui-kit';
import * as React from 'react';

import styles from './OfferCardSkeleton.css';

/** Скругление текстовых шейпов из макета */
const TEXT_BORDER_RADIUS = 12;
/** Скругление фотографий совпадает со скруглением реальной галереи */
const PHOTO_BORDER_RADIUS = 16;

/**
 * Скелетон карточки объявления: показывается вместо выдачи, пока она перезапрашивается.
 * Размеры повторяют реальный сниппет, чтобы страница не прыгала, когда приедут объявления.
 */
export const OfferCardSkeleton: React.FC = () => {
  return (
    <SkeletonGroup className={styles['card']} data-testid="OfferCardSkeleton">
      {/* Раскладка на своём элементе: у корня SkeletonGroup собственный flex-direction */}
      <div className={styles['columns']}>
        <Skeleton width={375} height={365} borderRadius={PHOTO_BORDER_RADIUS} />

        <div className={styles['main-info']}>
          <div className={styles['title-block']}>
            <Skeleton width={335} height={36} borderRadius={TEXT_BORDER_RADIUS} />
            <Skeleton width={344} height={24} borderRadius={TEXT_BORDER_RADIUS} />
            <Skeleton width="100%" height={24} borderRadius={TEXT_BORDER_RADIUS} />
          </div>
          <Skeleton width={259} height={34} borderRadius={TEXT_BORDER_RADIUS} />
          <Skeleton width="100%" height={175} borderRadius={TEXT_BORDER_RADIUS} />
        </div>

        <div className={styles['aside']}>
          <Skeleton width="100%" height={192} borderRadius={PHOTO_BORDER_RADIUS} />
          <Skeleton width="100%" height={24} borderRadius={TEXT_BORDER_RADIUS} />
          <Skeleton width="100%" height={24} borderRadius={TEXT_BORDER_RADIUS} />
        </div>
      </div>
    </SkeletonGroup>
  );
};
